import React from 'react';

/**
 * The open, non-blocking contract task shown with an accepted LA until the
 * program's contract exists. It has no due date and no action.
 */
export default function LaContractTask({ name }) {
    return (
        <div className="mt-2" data-testid="la-contract-task">
            <p className="fw-semibold mb-0">
                {`Complete your LA contract with ${name || 'your instructor'} (coming soon)`}
            </p>
            <p className="text-body-secondary mb-0">
                The LA program will share the contract and how to complete it.
            </p>
        </div>
    );
}
